import { Button } from "@/components/ui/button";
import Layout from "@/components/Layout";
import { Link } from "react-router-dom";

export default function PermissionDenied({
  title = "Permission denied",
  message = "You don’t have permission to access this page.",
  backTo = "/dashboard",
  backLabel = "Back to dashboard",
}: {
  title?: string;
  message?: string;
  backTo?: string;
  backLabel?: string;
}) {
  return (
    <Layout title={title}>
      <div className="glass-card p-8 max-w-2xl">
        <h1 className="text-2xl font-display font-bold text-foreground">{title}</h1>
        <p className="text-sm text-muted-foreground mt-2">{message}</p>
        <div className="mt-6 flex flex-wrap gap-2">
          <Link to={backTo}>
            <Button variant="premium">{backLabel}</Button>
          </Link>
        </div>
      </div>
    </Layout>
  );
}

